import {Chips} from 'plugins/modules/filter/components/Chips';
import {ICatalogCombo} from 'modules/products/types';
import React, {FC, useCallback, useContext} from 'react';
import style from './style.module.scss';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {EventAction, EventContextType} from 'modules/google-analytics/constants';
import {findFilterWithValueByCombo, getFilterTitleForGtag} from 'plugins/modules/filter/helpers';
import {IFilterFacet, IFilterFacetEnum, IFilterFacetVariant} from 'plugins/modules/filter/types';

export interface IProps {
    comboFiltersList: ICatalogCombo[];
    onChange: (
        pathName: string,
        filter: (IFilterFacet & {value: IFilterFacetVariant['code'] | IFilterFacetEnum['code']}) | null,
        isChecked: boolean,
    ) => void;
}

export const ComboFiltersList: FC<IProps> = ({comboFiltersList, onChange}) => {
    const {filterList} = useContext(FilterContext);

    const sendFiltersGtag = useFiltersGtag();

    const handleChange = useCallback(
        (pathName: string, catalogCombo: ICatalogCombo) => (isChecked: boolean) => {
            const filter = findFilterWithValueByCombo(filterList, catalogCombo);

            sendFiltersGtag(
                `${getFilterTitleForGtag(filterList, catalogCombo)}`,
                isChecked ? EventAction.AddFilter : EventAction.RemoveFilter,
                EventContextType.FilterTopSide,
            );

            onChange(pathName, filter, isChecked);
        },
        [filterList, onChange, sendFiltersGtag],
    );

    return (
        <div className={style.main}>
            {comboFiltersList.map((filterVariant) => {
                const {title, value, isActive} = filterVariant;

                return (
                    <a href={value} key={value} data-skeleton-item={true}>
                        <Chips
                            isDefaultChecked={isActive ?? false}
                            key={`${title}-${value}`}
                            onChange={handleChange(value, filterVariant)}
                            title={title}
                        />
                    </a>
                );
            })}
        </div>
    );
};
